import { render, staticRenderFns } from "./AstroCalendarNoticeDialog.vue?vue&type=template&id=ed76133a&"
import script from "./AstroCalendarNoticeDialog.vue?vue&type=script&lang=js&"
export * from "./AstroCalendarNoticeDialog.vue?vue&type=script&lang=js&"
import style0 from "./AstroCalendarNoticeDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed76133a')) {
      api.createRecord('ed76133a', component.options)
    } else {
      api.reload('ed76133a', component.options)
    }
    module.hot.accept("./AstroCalendarNoticeDialog.vue?vue&type=template&id=ed76133a&", function () {
      api.rerender('ed76133a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/共時曆/AstroCalendarNoticeDialog.vue"
export default component.exports